'use strict';

var $ = require('jquery');

const winwidth = window.innerWidth;
window.onYouTubeIframeAPIReady = function() {
	var ytPlayers = {};
	$('#hero .yt-video').each(function(index){
		var id = 'yt-' + index;
		var iframe = this;
		$(iframe).attr('id', id);
		ytPlayers[id] = new window.YT.Player(id, {
			events: {
				onReady: function(){

					ytPlayers[id].mute();
					var videoElement = $(iframe).closest('.video-wrapper'),
					mask = $(videoElement).find('.video-mask'),
					title = $(videoElement).find('.hero-title');

					if(winwidth > 829){
						ytPlayers[id].playVideo();
						mask.addClass('play');
						title.addClass('play');
					}else{
						ytPlayers[id].pauseVideo();
						$('.pausebutton').addClass('play');
						$('.video-mask').addClass('show');
						$('.video-mask').removeClass('play');
						$('.hero-title').removeClass('play');
					}

					$(videoElement).find('.pausebutton').on('click', function() {
						$(this).toggleClass('play');
						$(this).siblings('.video-mask').toggleClass('show');

						if (ytPlayers[id].getPlayerState() === 1) {
							ytPlayers[id].pauseVideo();
							mask.removeClass('play');
							title.removeClass('play');
						} else {
							mask.addClass('play');
							title.addClass('play');
							ytPlayers[id].playVideo();
						}	
					});

					$(window).on('resize', function(){

						if(window.innerWidth > 829){
							// add logics if needed
						}
						else{
							ytPlayers[id].pauseVideo();
							$('.pausebutton').addClass('play');
							$('.video-mask').addClass('show');
							$('.video-mask').removeClass('play');
							$('.hero-title').removeClass('play');
						}
					});

				},
				onStateChange: function(e){
					if (e.data === window.YT.PlayerState.ENDED) {
						ytPlayers[id].playVideo(); 
					}
				}
			}
		});
	});
};

$(window).on('load',function(){
	var ytApi = false;
	var vimeoApi = false;
	$('#hero .video-wrapper iframe').each(function(index){
		// Check if this is youtube iframe
		if($(this).attr('src').match(/youtube-nocookie\.com\/embed/)){
			$(this).attr('id', 'yt-' + index);
			$(this).addClass('yt-video');
			ytApi = true;
		}else if($(this).attr('src').match(/player\.vimeo\.com/)){
			$(this).attr('id', 'vimeo-' + index);
			$(this).addClass('vimeo-video');
			vimeoApi = true;
		}
	});


	var script;
	if(ytApi){
		script = $('<script>').attr('src', 'https://www.youtube.com/iframe_api');
		script.insertBefore( $('script').first() );
		script = $('<script>').attr('src', 'https://player.vimeo.com/api/player.js');
		script.insertBefore( $('script').first() );
	}
	if(vimeoApi){
		script = $('<script>').attr('src', 'https://www.youtube.com/iframe_api');
		script.insertBefore( $('script').first() );
		script = $('<script>').attr('src', 'https://player.vimeo.com/api/player.js');
        script.insertBefore( $('script').first() );
	}
});
